import { apiClient } from './client';
import type { Language, UserProfile } from '@/types';

interface RawUserProfile {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    language_id: number;
}

function mapProfile(raw: RawUserProfile): UserProfile {
    return {
        id: raw.id,
        firstName: raw.first_name,
        lastName: raw.last_name,
        email: raw.email,
        languageId: raw.language_id,
    };
}

export const profileApi = {
    async get(): Promise<UserProfile> {
        const raw = await apiClient.get<RawUserProfile>('account/profile');
        return mapProfile(raw);
    },

    async update(data: Partial<Pick<UserProfile, 'firstName' | 'lastName'>>): Promise<UserProfile> {
        const raw = await apiClient.put<RawUserProfile>('account/profile', {
            ...(data.firstName !== undefined && { first_name: data.firstName }),
            ...(data.lastName !== undefined && { last_name: data.lastName }),
        });
        return mapProfile(raw);
    },

    getLanguages() {
        return apiClient.get<Language[]>('definitions/languages');
    },

    setLanguage(languageId: number) {
        return apiClient.put('account/language', { language_id: languageId });
    },
};
